<template>
<div v-if="messagesToShow.length > 0">
    <message-card v-for="message in messagesToShow" :key="message.id" :message="message" />
    <div v-if="messagesToShow.length > 1" style="height: 10vh;"></div>
</div>
<div v-else>
 <h3>{{ t('messages.noMessagesLabel') }}</h3>
</div>
</template>

<script>
import MessageCard from './MessageCard.vue';
import { mapGetters } from "vuex";
import { messagesbyPriorityandDateTime } from '../utils/textToSpeechUtils'
import { useI18n } from 'vue-i18n';

export default {
    components: {
        MessageCard
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  props: {
    latestMessageOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "getmessagesForQRCode",
    ]),
    messagesToShow() {
      const messages = this.getmessagesForQRCode ?? [];
      return this.latestMessageOnly
      ? [...messagesbyPriorityandDateTime(messages)].slice(0,1)
      : [...messagesbyPriorityandDateTime(messages)];
    },
  },
};
</script>

<style>
</style>